import { render, staticRenderFns } from "./voteResult.vue?vue&type=template&id=01ebb9a4&"
import script from "./voteResult.vue?vue&type=script&lang=ts&"
export * from "./voteResult.vue?vue&type=script&lang=ts&"
import style0 from "./voteResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports